import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import MisListScreen from "../mis_list_screen";
import MisDetailScreen from "../mis_detail_screen";
import MisGridScreen from "../mis_grid_screen";

/**
 * Phase 8A — MIS routes. Only the list screen for now. Grid + detail screens
 * arrive in 8C.
 */
// Panel visibility gates on MODULE.mis_panel; per-MIS operations gate on
// MODULE.mis inside each screen. Finer BU/Dept scoping arrives in Phase 8E.
const mis_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.mis_list,
    component: MisListScreen,
    module: MODULE.mis_panel,
    main_module: MODULE.mis_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.mis_root,
    component: MisListScreen,
    module: MODULE.mis_panel,
    main_module: MODULE.mis_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.mis_view + "/:id",
    component: MisDetailScreen,
    module: MODULE.mis_panel,
    main_module: MODULE.mis_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.mis_grid + "/:id",
    component: MisGridScreen,
    module: MODULE.mis_panel,
    main_module: MODULE.mis_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default mis_routes;
